import { ProductSortField } from "@/graphql/codegen/graphql"

/**
 * TODO: BE needs to be updated
 */
export type ProductSortableAccessorKey =
  | "name"
  | "locationName"
  | "productId"
  | "publicId"
  | "companyProductDescription"
  | "vendorDescription"
  | "vendorSku"
  | "shipFromLocation"

export const accessorKeyToProductSortField = new Map<ProductSortableAccessorKey, ProductSortField>([
  ["name", ProductSortField.CompanyName],
  ["locationName", ProductSortField.LocationName],
  ["productId", ProductSortField.ProductId],
  ["publicId", ProductSortField.PublicId],
  ["companyProductDescription", ProductSortField.ProductSupplierDescription],
  ["vendorDescription", ProductSortField.ProductVendorDescription],
  ["vendorSku", ProductSortField.VendorSku],
  ["shipFromLocation", ProductSortField.ShipFromLocation],
])

export const productSortFieldToAccessoryKey = new Map<ProductSortField, ProductSortableAccessorKey>([
  [ProductSortField.CompanyName, "name"],
  [ProductSortField.LocationName, "locationName"],
  [ProductSortField.ProductId, "productId"],
  [ProductSortField.PublicId, "publicId"],
  [ProductSortField.ProductSupplierDescription, "companyProductDescription"],
  [ProductSortField.ProductVendorDescription, "vendorDescription"],
  [ProductSortField.VendorSku, "vendorSku"],
  [ProductSortField.ShipFromLocation, "shipFromLocation"],
])
